import React from 'react';
import PropTypes from 'prop-types';
import { createUseStyles, useTheme } from 'react-jss';
import * as typography from '../typography';

const useStyles = createUseStyles(theme => ({
  button: {
    ...typography.textRegular,
    ...theme.buttons.tertiary,
    alignItems: 'center',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    height: 32,
    width: 32,
    padding: 0,
  },
  icon: {
    width: 16,
    height: 16,
  },
}));

const IconButtonTertiary = ({ icon, ...props }) => {
  const theme = useTheme();
  const classes = useStyles({ ...props, theme });
  delete props.theme; // eslint-disable-line react/prop-types, no-param-reassign
  const Icon = icon;
  return (
    <button type="button" className={classes.button} {...props}>
      {icon && <Icon className={classes.icon} />}
    </button>
  );
};

IconButtonTertiary.propTypes = {
  icon: PropTypes.func,
};

IconButtonTertiary.defaultProps = {
  icon: null,
};

export default IconButtonTertiary;
